export const formatRentalPeriod = (period) => {
  switch (period) {
    case 'monthly':
      return '/ Mo';
    case 'yearly':
      return '/ Yr';
    case 'weekly':
      return '/ Wk';
    case 'daily':
      return '/ Day';
    case 'lease':
      return 'Lease';
    default:
      return ''; 
  }
};
